import Button from "@mui/material/Button";
import CircularProgress from "@mui/material/CircularProgress";

export default function LoadingButton({label, color, variant, onclick, loading = false, ...props}) {
  return (
    <Button
      variant={!!variant ? variant : "contained"}
      onClick={onclick}
      color={color}
      disabled={loading || props.disabled}
      {...props}
    >
      {loading ? <CircularProgress size={20} color="inherit" /> : label}
    </Button>
  )
}